import type { TelemetryModule } from "../di/define-module.js";
import type { TelemetryPlatform } from "../platforms/types.js";
import { createModuleShell } from "./module-shell.js";
import type { PlatformBuildContext } from "./platform-context.js";

/** Built-in platform when `createTelemetry` omits `platform` — no framework subpath import. */
export const defaultTelemetryPlatform: TelemetryPlatform<TelemetryModule> = {
  id: "browser",
  buildModule(ctx: PlatformBuildContext<TelemetryModule>) {
    return createModuleShell(ctx);
  },
};
